import axios from 'axios';

/*
*  This file contains all axios calls related copy via content publishing campaign builder
*/

export const copyContent = async (funnelId, funnelName, packagePrefix) => {
    const publisherType = 'funnel';

    const { data } = await axios.post(
        '/app/contentPublishing/copyContent',
        `artifactName=${funnelName}&publisherType=${publisherType}&publishId=${funnelId}&packagePrefix=${packagePrefix}`,
    );

    return data;
};
